const localizers = {
  'loading.msg': () => `Učitavanje...`,
  'SASServer.genericError.msg': () => `Nije moguće uspostaviti vezu s poslužiteljem.`,
  'SASReport.genericError.msg': () => `Nije moguće učitati odabrano izvješće.`,
  'SASReportImage.genericError.msg': () => `Sliku izvješća nije bilo moguće učitati.`,
  'SASReportImage.imageNotSupported.msg': () => `Slike nisu podržane za ovu vrstu sadržaja izvješća.`,
}
export default localizers;
